export enum ExportType {
  SignRequest = 'sign-requests',
  ScanRequest = 'scan-requests',
  Customer = 'customers',
  ClientUser = 'client-users',
  User = 'user',
  Dashboard = 'dashboard',
}
